import { initTagsInput } from "../plugins/bootstrap-tagsinput";
import { initFileDownload } from "../plugins/jquery.fileDownload";
export default class Commons {
  constructor() {
    this.ui = {};
  }

  loadComponents() {
    this.tagsInput();
    this.onlyNumber();
    this.loadSearchForm();
    this.loadTooltipsPopovers();
    this.sendRequest();
    this.fileInput();
    this.loadSelectSegment();
    this.loadDate();
    this.loadSelect2();
    this.loadDateMinMax();
    this.hideMessages();
    initFileDownload();
  };

  needFormValidation(options) {
    var operation = this;
    var options = options || {};

    $.extend($.validator.defaults, {
      errorElement: 'span',
      errorClass: 'invalid-feedback',
      success: function (label, element) {
        label.parent().removeClass('error');
        label.remove();
      },
      errorPlacement: function (error, element) {
        if (element.parent('.input-group').length || element.prop('type') === 'checkbox' || element.prop('type') === 'radio') {
          error.insertAfter(element.parent());
        } else if ((element.prop('type') === 'select-multiple' && element.hasClass("select2")) || $(element).hasClass("select2")) {
          error.insertAfter(element.closest("div").find("span.select2"));
        } else {
          error.insertAfter(element);
        }
      },
      highlight: function (element, errorClass, validClass) {
        if (($(element).prop('type') === 'select-multiple' && $(element).hasClass("select2")) || $(element).hasClass("select2")) {
          $(element).closest("div").find("span.select2-selection").addClass("is-invalid");
        } else {
          $(element).parents(".form-group").addClass("error").removeClass("has-success");
        }
      },
      unhighlight: function (element, errorClass, validClass) {
        if (($(element).prop('type') === 'select-multiple' && $(element).hasClass("select2")) || $(element).hasClass("select2")) {
          $(element).closest("div").find("span.select2-selection").removeClass("is-invalid");
        } else {
          $(element).parents(".form-group").addClass("").removeClass("error");
        }
      }
    });

    $('.js-validate').validate(options);
  };

  tagsInput() {
    initTagsInput();

    if (typeof $.fn.tagsinput !== "function") {
      console.warn("tagsinput no está definido aún");
      return;
    };

    $('.js-tagsinput').tagsinput({
      freeInput: true
    });

    $('.js-tagsinput-email').tagsinput({ freeInput: true });

    $('.bootstrap-tagsinput input').on('keypress', function (e) {
      if (e.keyCode === 13) {
        e.keyCode = 188;
        e.preventDefault();
      };
    });

    $('.js-tagsinput').on('beforeItemAdd', function (event) {
      event.cancel = !(/^[0-9]+$/.test(event.item));
    });

    $('.js-tagsinput-email').on('beforeItemAdd', function (event) {
      var validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/
      var email = event.item.trim();

      if (!validEmail.test(email)) {
        event.cancel = true
      };
    });
  };

  onlyNumber() {
    $(".js-only-number").on('keydown', function (evt) {
      var keys = [
        8, // backspace
        9, // tab
        13, // enter
        46, // delete
        37, 39, 38, 40 // arrow keys<^>v
      ]

      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105) && $.inArray(event.which, keys) == -1) {
        return false;
      }

      return true;
    });
  };

  loadSearchForm() {
    $("form#searchForm").bind("ajax:beforeSend", function (event, data, status, xhr) {
      $("#ajax_indicator_search").show();
      return true
    }).bind("ajax:complete", function (event, data, status, xhr) {
      $("#ajax_indicator_search").hide();
    }).bind("ajax:success", function (event, data, status, xhr) {
      $("#ajax_indicator_search").hide();
    });

    $("form#searchForm #q").keyup(function (e) {
      if ($("form#searchForm #q").get(0).value == '') {
        e.preventDefault();
        $("form#searchForm").sendRequest();
      }
    });

    $("form#searchForm .js-q").keyup(function (e) {
      if ($("form#searchForm .js-q").get(0).value == '') {
        e.preventDefault();
        $("form#searchForm").sendRequest();
      }
    });
  };

  loadTooltipsPopovers() {
    this.hideLoadTooltipsPopovers();
    // Tooltip
    $('[data-toggle="tooltip"]').tooltip({
      html: true
    });

    // Popovers
    $('[data-toggle="popover"]').popover({
      placement: 'left',
      trigger: 'click',
      sanitize: false
    });

    $('[data-toggle="popover"]').click(function (e) {
      e.preventDefault();
    });
  };

  hideLoadTooltipsPopovers() {
    $('[data-toggle="popover"]').on('show.bs.popover', function (e) {
      $('[data-toggle="tooltip"]').tooltip('hide');
      $('[data-toggle="popover"]').popover('hide');
    });

    $('body').on('click', function (e) {
      $('[data-toggle="popover"]').each(function () {
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
          $(this).popover('hide');
        }
      });
    })
  }

  sendRequest() {
    jQuery.fn.extend({
      sendRequest: function () {
        $("#ajax_indicator_search").show();
        $.ajax({
          method: "GET",
          url: this.attr('action'),
          dataType: "script",
          data: this.serialize()
        }).always(function () {
          $("#ajax_indicator_search").hide();
        })
      }
    });
  };

  fileInput() {
    $(document).on('change', '.custom-file-input', function (event) {
      var file = event.target.files && event.target.files[0];
      var filename = file ? file.name : 'Choose file';

      $(this).next('.custom-file-label, .custom-file-control').html(filename);
    })
  };

  loadSelectSegment() {
    $(".js-select-modality").on("change", function () {
      $(".js-select-segment").val(null).trigger('change');
    });

    $(".js-select-segment").select2({
      allowClear: true,
      placeholder: '',
      ajax: {
        url: '/get_segments',
        dataType: 'json',
        data: function (params) {
          var modality_id = "" || $(".js-select-modality").find('option:selected').val();
          var query = {
            q: params.term,
            modality_id: modality_id
          }
          return query;
        }
      }
    });
  };

  loadDate() {
    $('input.date').each(function () {
      $(this).datetimepicker({
        minDate: moment("01/03/2021"),
        format: "DD/MM/YYYY",
        useCurrent: true
      });
    });
  };

  loadSelect2() {
    $('select.select2').each(function () {
      $(this).select2({
        placeholder: $(this).data('placeholder') || "",
        allowClear: true,
      });
    });
  };

  loadDateMinMax() {
    $('#from').datetimepicker({
      minDate: moment("05/01/2019"),
      format: "DD/MM/YYYY",
      useCurrent: true
    });

    $('#to').datetimepicker({
      minDate: moment("05/01/2019"),
      format: "DD/MM/YYYY",
      useCurrent: true
    });

    $("#from").on("dp.change", function (e) {
      $('#to').data("DateTimePicker").minDate(e.date);
    });

    $("#to").on("dp.change", function (e) {
      $('#from').data("DateTimePicker").maxDate(e.date);
    });
  };

  hideMessages() {
    $('#messages-bar').fadeIn().delay(3500).fadeOut('slow').queue(function () {
      $('#messages-bar').remove();
    });
  }
}
